<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card>
            <div class="groups" v-if="loaded">
                <div class="buttons">
                    <b-button :title="$t('general.add')" variant="primary" @click="openModal(true,'add',{list})">{{$t('general.add')}} </b-button>
                </div>
                <b-form inline class="formBox"> 
                    <div class="inputGrp text-left" >
                        <b-table-simple
                        :borderless="true"
                        :small="true"
                        head-variant="none"
                        class="w-50"
                        >
                        <b-thead>
                            <h4>{{vacation.name}}</h4>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-th>{{$t('defination.vacation.list.is_every_year')}}</b-th>
                                <b-td>
                                    <b-icon icon="check" variant="success" v-if="vacation.is_every_year"></b-icon>
                                    <b-icon icon="x" variant="danger" v-else></b-icon>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{$t('defination.vacation.list.begin_date')}}</b-th>
                                <b-td>{{moment(vacation.begin_date)}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{$t('defination.vacation.list.end_date')}}</b-th>
                                <b-td>{{moment(vacation.end_date)}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{$t('defination.vacation.job.job_count')}}</b-th>
                                <b-td>{{list?list.length:0}}</b-td>
                            </b-tr>
                        </b-tbody>
                        </b-table-simple>
                        <b-table-simple hover responsive v-if="list">
                            
                            <b-thead>
                                <b-th>{{$t('defination.vacation.job.job')}}</b-th>
                                <b-th> </b-th>
                            </b-thead>
                            <b-tbody class="text-left">
                                <b-tr v-for="item in list" :key="item.id">
                                    
                                    <b-td> {{item.name}}</b-td>
                                    <b-td> 
                                        <div class="buttons">
                                            <b-button size="sm" :title="$t('general.delete')" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete',{vacationId, jobId: item.id})"></b-icon> </b-button>
                                        </div>
                                   </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                        <b-alert show variant="light" v-else>{{$t('defination.vacation.job.no_results')}}</b-alert>
                    </div>
                   
                </b-form>
            </div>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import moment from 'moment'
    import Modals from './modals/';


    let breadCrumb = [
        { label: i18n.t('pages.defination.name'), url: "/Defination" },
        { label: i18n.t('pages.defination.vacation'), url: "/Defination/Vacations" },
    ]
    export default {
        name: "VacationsJobs",
        data: function(){
            return{
                vacationId: this.$route.params.id,
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"VacationsJobs",
                modalName: "",
                loaded:false
            }
        },
        components:{
            BreadCrumb, Modals
        },
        async created(){
            await this.$store.dispatch("listVacationJobs", {vacationId: this.vacationId})
            await this.$store.dispatch("listVacation", this.vacationId)
            this.loaded = true
        },
        computed: {
            list() {
                return this.$store.getters.getVacationJobs;
            },
            vacation() {
                return this.$store.getters.getVacation
            },
        },
        methods:{
            moment: function(data){
                return moment(data).format('DD MMMM YYYY hh:mm');
            },
            openModal: function(state, modal, props){
                this.modalOpen = state;
                this.modalProps = props;
                this.modalName = modal;
            },
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/signalGroups.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/VacationsJobs.vue